import React from 'react';
import { MapPin, Phone } from 'lucide-react';
import { Button } from './ui/button';

const ServiceAreasSection = () => {
  const serviceAreas = [
    { name: 'Dandenong', postcode: '3175' },
    { name: 'Keysborough', postcode: '3173' },
    { name: 'Noble Park', postcode: '3174' },
    { name: 'Springvale', postcode: '3171' },
    { name: 'Dandenong North', postcode: '3175' },
    { name: 'Dandenong South', postcode: '3164' },
    { name: 'Noble Park North', postcode: '3174' },
    { name: 'Springvale South', postcode: '3172' },
    { name: 'Bangholme', postcode: '3175' },
    { name: 'Lyndhurst', postcode: '3975' },
    { name: 'Dingley Village', postcode: '3172' },
    { name: 'Clayton South', postcode: '3169' }
  ];

  return (
    <section id="service-areas" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <span className="text-green-600">Service Areas</span> We Cover
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We provide professional lawn mowing and garden maintenance services across Melbourne's southeast suburbs.
          </p>
        </div>

        {/* Areas Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-12">
          {serviceAreas.map((area, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-300 border-2 border-gray-100 hover:border-green-200 transform hover:-translate-y-1"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="h-5 w-5 text-green-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 text-sm sm:text-base">{area.name}</h3>
                  <p className="text-xs text-gray-500">{area.postcode}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="bg-white rounded-2xl p-8 sm:p-10 shadow-lg border-2 border-green-100">
          <div className="text-center max-w-3xl mx-auto">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
              Don't See Your Suburb?
            </h3>
            <p className="text-gray-600 mb-6">
              We service many surrounding areas across Melbourne's southeast. Give us a call or send a message to check if we cover your location.
            </p>
            <a href="tel:0434600945">
              <Button className="bg-green-600 hover:bg-green-700 text-white px-8 py-6 text-lg font-semibold rounded-xl flex items-center gap-3 shadow-lg hover:shadow-xl transition-all mx-auto">
                <Phone className="h-5 w-5" />
                Call or Text: 0434 600 945
              </Button>
            </a>
          </div>
        </div>

        {/* SEO Keywords Section */}
        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">
            Searching for <span className="font-semibold text-gray-700">lawn mowing near me</span>,{' '}
            <span className="font-semibold text-gray-700">best lawn mowing near me</span>, or{' '}
            <span className="font-semibold text-gray-700">local lawn mowing service</span>?{' '}
            Mini Mike Mowing provides affordable and professional lawn care across Dandenong, Keysborough, Noble Park, and Springvale.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
